import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { useSubscription } from "@/hooks/useSubscription";
import { useSingleInstance } from "@/hooks/useSingleInstance";
import { SITE } from "@/lib/constants";
import { cn } from "@/lib/utils";

/**
 * Faixa do teste sem cartão (plano 'teste' ou 'cortesia'). Some para quem já
 * tem assinatura no Stripe. Nos últimos 3 dias ganha destaque.
 */
export function TrialBanner() {
  const { isTesteSemCartao, diasTesteRestantes } = useSubscription();
  const isOwner = useSingleInstance("trial-banner");

  if (!isOwner || !isTesteSemCartao || diasTesteRestantes === null) return null;

  const urgent = diasTesteRestantes <= 3;
  const prazo =
    diasTesteRestantes === 0
      ? "Seu teste termina hoje"
      : diasTesteRestantes === 1
        ? "Seu teste termina em 1 dia"
        : `Seu teste termina em ${diasTesteRestantes} dias`;

  return (
    <div
      className={cn(
        "flex flex-wrap items-center gap-x-2 gap-y-1 border-b px-6 text-sm",
        urgent
          ? "py-3 font-semibold bg-destructive/10 border-destructive/30 text-destructive"
          : "py-1.5 bg-muted border-border text-muted-foreground",
      )}
    >
      <Clock className="h-4 w-4" />
      <span>{prazo}</span>
      <span aria-hidden>·</span>
      <Link to="/planos" className="underline underline-offset-2 hover:text-foreground">
        Assinar por {SITE.PRECO_MENSAL_FORMATADO}/mês
      </Link>
    </div>
  );
}

export default TrialBanner;
